import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen p-6 max-w-4xl mx-auto">
      <Button 
        variant="ghost" 
        onClick={() => navigate(-1)}
        className="mb-6"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Voltar
      </Button>

      <h1 className="text-3xl font-bold mb-6">Termos de Uso</h1>
      
      <div className="space-y-6 text-muted-foreground">
        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">1. Aceitação dos Termos</h2>
          <p>
            Ao acessar e usar o aplicativo You Better Run ("YBR"), você concorda em cumprir estes Termos de Uso. 
            Se você não concordar com qualquer parte destes termos, não poderá usar nosso serviço.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">2. Descrição do Serviço</h2>
          <p>
            O YBR é uma plataforma de corrida que oferece:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Rastreamento de corridas via GPS</li>
            <li>Sistema de mentoria</li>
            <li>Comunidade local de corredores</li>
            <li>Recursos de gamificação e progressão</li>
            <li>Funcionalidade SOS de segurança</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">3. Responsabilidades do Usuário</h2>
          <p>Você concorda em:</p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Fornecer informações precisas e atualizadas</li>
            <li>Manter a confidencialidade de sua conta</li>
            <li>Usar o serviço de forma responsável e legal</li>
            <li>Respeitar outros usuários e mentores</li>
            <li>Não compartilhar conteúdo ofensivo ou inadequado</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">4. Saúde e Segurança</h2>
          <p className="mb-2">
            <strong>IMPORTANTE:</strong> O YBR não substitui orientação médica profissional.
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Consulte um médico antes de iniciar qualquer programa de exercícios</li>
            <li>A funcionalidade SOS é complementar, não substitui serviços de emergência oficiais</li>
            <li>Você é responsável por sua própria segurança durante as corridas</li>
            <li>O aplicativo não garante prevenção de lesões ou resultados específicos</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">5. Privacidade de Dados</h2>
          <p>
            Coletamos e processamos seus dados conforme nossa{' '}
            <a href="/privacy" className="text-primary hover:underline">Política de Privacidade</a>.
            Isso inclui dados de localização durante corridas, métricas de desempenho e interações sociais.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">6. Propriedade Intelectual</h2>
          <p>
            Todo o conteúdo do YBR (design, código, textos, logos) é propriedade da You Better Run e está 
            protegido por leis de direitos autorais. Você não pode copiar, modificar ou distribuir nosso conteúdo 
            sem autorização.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">7. Limitação de Responsabilidade</h2>
          <p>
            O YBR não se responsabiliza por:
          </p>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Lesões físicas decorrentes da prática de corrida</li>
            <li>Falhas técnicas ou interrupções do serviço</li>
            <li>Perda de dados ou informações</li>
            <li>Ações de outros usuários ou terceiros</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">8. Modificações dos Termos</h2>
          <p>
            Reservamos o direito de modificar estes termos a qualquer momento. Usuários serão notificados 
            sobre mudanças significativas. O uso continuado após mudanças constitui aceitação dos novos termos.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">9. Rescisão</h2>
          <p>
            Podemos suspender ou encerrar sua conta se você violar estes termos. Você pode encerrar sua conta 
            a qualquer momento através das configurações do aplicativo.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">10. Contato</h2>
          <p>
            Para dúvidas sobre estes termos, entre em contato: suporte@youbetterrun.app
          </p>
        </section>

        <div className="pt-6 border-t text-sm">
          <p>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
